import { GridColDef } from '@mui/x-data-grid';

export const totalUsersColumns: GridColDef[] = [
  {
    field: 'name',
    minWidth: 100,
    headerName: '이름',
    flex: 1,
  },
  {
    field: 'value',
    minWidth: 100,
    headerName: '총 유저 수',
    align: 'right',
    flex: 1,
  },
];

export const totalCountColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: '이름',
    flex: 1,
  },
  {
    field: 'value',
    headerName: '총 참여 횟수',
    align: 'right',
    flex: 1,
  },
];

export const totalAmountColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: '이름',
    flex: 1,
  },
  {
    field: 'value',
    headerName: '베팅 총액',
    align: 'right',
    flex: 1,
  },
];

export const costSmallColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: '이름',
    flex: 1,
  },
  {
    field: 'value',
    headerName: '소액 베팅 비용',
    align: 'right',
    flex: 1,
  },
];

export const winStatusColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: '이름',
    flex: 1,
  },
  {
    field: 'win_amount',
    headerName: '당첨 금액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'count',
    headerName: '당첨 횟수',
    align: 'right',
    flex: 1,
  },
];

export const smallWinUsersColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },
  {
    field: 'amount',
    headerName: '당첨 금액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'type',
    headerName: '게임종류',
    flex: 1,
  },

  {
    field: 'memo',
    headerName: '메모',
    flex: 1,
  },

  {
    field: 'regDt',
    headerName: '등록일',
    flex: 1,
  },
];

export const swapToTokenColumns: GridColDef[] = [
  {
    field: 'betAmount',
    headerName: '베팅 포인트',
    align: 'right',
    flex: 1,
  },
  {
    field: 'totAmount',
    headerName: '토큰 금액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'count',
    headerName: 'count',
    align: 'right',
    flex: 1,
  },
];

export const swapToPointColumns: GridColDef[] = [
  {
    field: 'betAmount',
    headerName: '베팅 포인트',
    align: 'right',
    flex: 1,
  },
  {
    field: 'totAmount',
    headerName: '토큰 금액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'count',
    headerName: 'count',
    align: 'right',
    flex: 1,
  },
];

export const swapToTokenListColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },
  {
    field: 'bet_amount',
    headerName: 'bet point',
    align: 'right',
    flex: 1,
  },
  {
    field: 'token_amount',
    headerName: 'token_amount',
    align: 'right',
    flex: 1,
  },
  {
    field: 'hash',
    headerName: 'hash',
    flex: 1,
  },

  {
    field: 'symbol',
    headerName: 'symbol',
    flex: 1,
  },
  {
    field: 'ticker',
    headerName: 'ticker',
    align: 'right',
    flex: 1,
  },

  {
    field: 'reg_dt',
    headerName: 'reg_dt',
    flex: 1,
  },
];

export const swapToPointListColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },
  {
    field: 'bet_amount',
    headerName: 'bet point',
    align: 'right',
    flex: 1,
  },
  {
    field: 'token_amount',
    headerName: 'token_amount',
    align: 'right',
    flex: 1,
  },
  {
    field: 'hash',
    headerName: 'hash',
    flex: 1,
  },

  {
    field: 'symbol',
    headerName: 'symbol',
    flex: 1,
  },
  {
    field: 'ticker',
    headerName: 'ticker',
    flex: 1,
  },

  {
    field: 'reg_dt',
    headerName: 'reg_dt',
    flex: 1,
  },
];
export const mismatchDataColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },
  {
    field: 'total_amount',
    align: 'right',
    headerName: '합계',
    flex: 1,
  },

  {
    field: 'ledger_amount',
    align: 'right',
    headerName: '원장 합계',
    flex: 1,
  },
  {
    field: 'result',
    headerName: '결과(0불일치)',
    flex: 1,
    minWidth: 100,
  },
];

export const gameSettingColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: '이름',
    flex: 1,
  },
  {
    field: 'tot_amount',
    headerName: '기본당첨금',
    align: 'right',
    flex: 1,
  },
  {
    field: 'jackpot_amount',
    headerName: '잭팟 지급금',
    align: 'right',
    flex: 1,
  },
  {
    field: 'jackpot_ready',
    headerName: '잭팟 준비금',
    align: 'right',
    flex: 1,
  },
];

export const betUserListColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },
  {
    field: 'total',
    headerName: 'total',
    align: 'right',
    flex: 1,
  },
  {
    field: 'total_count',
    headerName: 'total_count',
    align: 'right',
    flex: 1,
  },
];

export const smallWinListColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },

  {
    field: 'amount',
    headerName: '수량',
    align: 'right',
    flex: 1,
  },
  {
    field: 'type',
    headerName: '게임종류',
    align: 'right',
    flex: 1,
  },
  {
    field: 'memo',
    headerName: 'memo',
    flex: 1,
  },
  {
    field: 'reg_dt',
    headerName: '등록일',
    align: 'right',
    flex: 1,
  },
];

export const SwapListColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },

  {
    field: 'bet_amount',
    headerName: '포인트 금액',
    align: 'right',
    flex: 1,
  },

  {
    field: 'token_amount',
    headerName: '토큰 금액',
    align: 'right',
    flex: 1,
  },

  {
    field: 'symbol',
    headerName: '심볼',
    flex: 1,
  },

  {
    field: 'ticker',
    headerName: '시세',
    flex: 1,
  },

  {
    field: 'hash',
    headerName: '해시',
    flex: 1,
  },
  {
    field: 'reg_dt',
    headerName: '등록일',
    align: 'right',
    flex: 1,
  },
];

export const winUserListColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },
  {
    field: 'bet_amount',
    headerName: '베팅 금액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'win_amount',
    headerName: '당첨 금액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'reg_dt',
    headerName: '등록일',
    align: 'right',
    flex: 1,
  },
];

export const jackpotListColumns: GridColDef[] = [
  {
    field: 'address',
    headerName: 'address',
    flex: 1,
  },
  {
    field: 'amount',
    headerName: '금액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'rank',
    headerName: '랭킹',
    align: 'center',
    flex: 1,
  },
  {
    field: 'flag_jackpot',
    headerName: '당첨상태(0: 시스템, 1: 관리자)',
    align: 'center',
    flex: 1,
  },
  {
    field: 'reg_dt',
    headerName: '등록일',
    align: 'right',
    flex: 1,
  },
];

// 동적 컬럼 생성 함수
export const createBetUserListColumns = (data: any[]): GridColDef[] => {
  if (!data || data.length === 0) {
    return betUserListColumns; // 기본 컬럼 반환
  }

  // 첫 번째 데이터에서 게임 이름 필드들을 찾기
  const firstItem = data[0];
  const gameFields = Object.keys(firstItem).filter(
    (key) => key !== 'address' && key !== 'total' && key !== 'total_count',
  );

  // 기본 컬럼들
  const baseColumns: GridColDef[] = [
    {
      field: 'address',
      headerName: 'address',
      flex: 1,
    },
    {
      field: 'total',
      headerName: 'total',
      align: 'right',
      flex: 1,
    },
    {
      field: 'total_count',
      headerName: 'total_count',
      align: 'right',
      flex: 1,
    },
  ];

  // 동적 게임 컬럼들 생성
  const gameColumns: GridColDef[] = gameFields.map((field) => ({
    field: field,
    headerName: field, // 필드명 그대로 사용
    align: 'right',
    flex: 1,
  }));

  // // 상세보기 컬럼 추가 (클릭 가능한 텍스트)
  // const detailColumn: GridColDef = {
  //   field: 'detail',
  //   headerName: '상세보기',
  //   flex: 1,
  //   sortable: false,
  //   renderCell: (params) => {
  //     return '상세'; // 지갑주소 반환
  //   },
  // };

  return [...baseColumns, ...gameColumns];
};

export const referralDataColumns: GridColDef[] = [
  {
    field: 'referral_bet_amount',
    align: 'right',
    headerName: '베팅금액 누적 금액',
    flex: 1,
  },
  {
    field: 'referral_bet_count',
    align: 'right',
    headerName: '베팅금액 누적 횟수',
    flex: 1,
  },

  {
    field: 'referral_win_amount',
    align: 'right',
    headerName: '당첨금액 누적 금액',
    flex: 1,
  },
  {
    field: 'referral_win_count',
    align: 'right',
    headerName: '당첨금액 누적 횟수',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'referral_small_win_amount',
    align: 'right',
    headerName: '소당첨금액 누적 금액',
    flex: 1,
  },
  {
    field: 'referral_small_win_count',
    align: 'right',
    headerName: '소당첨금액 누적 횟수',
    flex: 1,
  },
  {
    field: 'total_amount',
    align: 'right',
    headerName: '누적 금액',
    flex: 1,
  },
  {
    field: 'total_count',
    align: 'right',
    headerName: '누적 횟수',
    flex: 1,
  },
];

export const referralListColumns: GridColDef[] = [
  {
    field: 'address',
    flex: 1,
    headerName: '지갑주소',
  },
  {
    field: 'amount',
    headerName: '수량',
    align: 'right',
    flex: 1,
  },
  {
    field: 'type',
    headerName: '게임종류',
    align: 'center',
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'status',
    align: 'center',
    flex: 1,
  },
  {
    field: 'memo',
    headerName: 'memo',
    flex: 1,
  },
  {
    field: 'reg_dt',
    headerName: 'reg_dt',
    align: 'right',
    flex: 1,
  },
];

export const rankingListColumns: GridColDef[] = [
  {
    field: 'rank',
    headerName: '랭킹',
    align: 'right',
  },
  {
    field: 'address',
    headerName: '지갑주소',
    flex: 1,
  },
  {
    field: 'total_amount',
    headerName: '총액',
    align: 'right',
    flex: 1,
  },
  {
    field: 'reg_dt',
    headerName: '등록일',
    align: 'right',
    flex: 1,
  },
  // {
  //   field: 'win_count',
  //   headerName: '당첨 횟수',
  //   align: 'right',
  //   flex: 1,
  // },
  // {
  //   field: 'small_win_count',
  //   headerName: '소액 당첨 횟수',
  //   align: 'right',
  //   flex: 1,
  // },
  // {
  //   field: 'jackpot_count',
  //   headerName: '잭팟 횟수',
  //   align: 'right',
  //   flex: 1,
  // },
];
